<div class="compass" fusePerfectScrollbar>

  <a routerLink="./../.." aria-label="précédent"
    class="compass__back__link">
    <mat-icon svgIcon="back"></mat-icon>
    <span>{{ 'compass.home' | translate }}</span>
  </a>

  <app-compass-search-form [searchValue]="query()" (done)="updateSearchQuery($event)"></app-compass-search-form>

  @if (themes(); as themes) {
    @if (themes.length > 0) {
      <section
        class="compass__news">
        <div class="compass__news__content grid-compass">
          @for (theme of themes; track theme) {
            <app-compass-card
              [ngStyle]="{'background-image': 'url(' + (theme.get('medias') && theme.get('medias')[0] ? theme.get('medias')[0].url : '') + ')'}"
              class="compass-card__news ">
              <div class="app-compass-card__header" data-header>
                <app-keywords>
                  @for (tag of theme.get('tags'); track tag) {
                    <span
                      class="keywords__item"
                      itemprop="keywords">
                      {{ tag.name }}
                    </span>
                  }
                </app-keywords>
              </div>
              <div class="app-compass-card__body"
                data-body>
                <h3 [innerHTML]="theme.get('label')"></h3>
                <div [innerHTML]="theme.get('body')"></div>
              </div>
              <div class="app-compass-card__footer"
                data-footer>
                <a [routerLink]="['themes', theme.id, 'ressources']"
                  [queryParams]="getQueryParams()"
                  class="app-compass-card__footer__button">
                  <mat-icon svgIcon="app-compass-card__footer__button__icon"></mat-icon>
                  <span>{{ 'compass.see_resources' | translate }}</span>
                </a>
              </div>
            </app-compass-card>
          }
        </div>
      </section>
    }
    @if (themes.length === 0) {
      <section>
        {{'compass.no_results' | translate}}
      </section>
    }
  }

  @if (isLoadingThemes) {
    <mat-spinner [diameter]="60" [strokeWidth]="5"></mat-spinner>
  }

</div>